<template>
  <article class="page-statistics-dep2per">
    <!-- chart panel -->
    <crm-panel class="chart-panel">
      <!-- total time -->
      <section class="tips-container">
        <span class="tips-container_text">数据统计于{{ totalTime }}</span>
      </section>
      <!-- toolbar -->
      <section class="select-container">
        <el-form :inline="true">
          <span class="select-container_label">三级部门业务统计</span>
          <el-select
            v-model="timeRangeAlias"
            @change="handleTimeRangeChange($event)"
          >
            <chart-total-time-options />
          </el-select>
          <el-date-picker
            v-show="isShown"
            v-model="time"
            value-format="yyyy-MM-dd"
            :editable="false"
            type="daterange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
          >
          </el-date-picker>
        </el-form>
        <div class="select-container_buttons">
          <!-- <crm-button
            v-if="webStatisticsAuth.datakanban.export.auth"
            buttonType="plain"
            text="导出"
            @click="handleExport()">
          </crm-button> -->
        </div>
      </section>
      <!-- total block -->
      <section class="total-container">
        <div
          class="total-container_block"
          v-for="totalBlock in totalBlockList"
          :key="totalBlock.tipText"
        >
          <crm-block v-bind="totalBlock" />
        </div>
      </section>
      <!-- chart -->
      <section class="chart-container" />
    </crm-panel>

    <!-- table panel -->
    <crm-panel class="table-panel">
      <!-- table -->
      <el-table
        :data="tableData.results"
        border
        v-loading="loading"
        height="100%"
        style="width: 100%"
      >
        <el-table-column
          fixed
          width="200"
          prop="teamName"
          label="团队"
          align="center"
        >
        </el-table-column>
        <el-table-column
          fixed
          prop="signingAmountStr"
          label="合同金额(万元)"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.signingAmountStr | conversion }}</span>
          </template>
        </el-table-column>
        <el-table-column
          fixed
          prop="grossProfitStr"
          label="毛利(万元)"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.grossProfitStr | conversion }}</span>
          </template>
        </el-table-column>
        <el-table-column
          fixed
          prop="refundAmountStr"
          label="回款金额(万元)"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.refundAmountStr | conversion }}</span>
          </template>
        </el-table-column>
        <el-table-column
          fixed
          prop="costAmountStr"
          label="成本(万元)"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.costAmountStr | conversion }}</span>
          </template>
        </el-table-column>
        <el-table-column
          fixed
          prop="grossProfitPerPersonStr"
          label="人均毛利(万元)"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.grossProfitPerPersonStr | conversion }}</span>
          </template>
        </el-table-column>
        <el-table-column
          fixed
          prop="perCapitaAmountTotalStr"
          label="人均回款(万元)"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.perCapitaAmountTotalStr | conversion }}</span>
          </template>
        </el-table-column>
        <el-table-column
          fixed
          prop="newContractNumberStr"
          label="新增合同数量(个)"
          align="center"
        >
        </el-table-column>
      </el-table>
      <!-- pageination -->
      <div class="pageination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="tableSearchForm.pageNumber"
          :page-sizes="[10, 20, 50]"
          :page-size="tableSearchForm.pageSize"
          layout="total, sizes, prev, pager, next"
          :total="tableData.totalCount"
        >
        </el-pagination>
      </div>
    </crm-panel>
  </article>
</template>

<script>
import moment from 'moment';
import * as echarts from 'echarts/echarts.common';
import { mapActions, mapGetters } from 'vuex';
import { performanceCount } from 'crm-common';

import { conversion } from '@/scripts/utils';
import http from '~services/axios';
import CHART_TOTAL_BLOCK_PROPS from '~services/constant/statistics/performance-total-block';
import CHART_API_CONFIG from '~api/statistics/performance-api-config';
import getTimeRangeByAlias from '~services/time-range';

import ChartTotalTimeOptions from '@/components/business/datastatistics/chart-total-time-options';
import CrmPanel from '@/components/base/crmPanel';
import CrmButton from '@/components/base/crmButton';
import CrmBlock from '@/components/base/crmBlock';

const {
  apiFactory,
  totalFactory,
  chartFactory: optionFactory,
} = performanceCount;
const diagramCommonApi = apiFactory(http, CHART_API_CONFIG);

// crm-common包中对每个图表定义的名称
const CHART_NAME = 'department3';

/**
 * TABLE_GETTER_NAME: vuex-store里对应的表格数据getter名称
 * TABLE_ACTION_NAME: vuex-store里对应的表格数据获取action名称
 *  */
const TABLE_GETTER_NAME = 'dep3OfBusPerformanceTableData';
const TABLE_ACTION_NAME = 'getDep3OfBusPerformanceTableData';

// echarts instance
let chart;
const echartsConfig = {
  devicePixelRatio: window.devicePixelRatio,
};
const defaultDataFormat = 'YYYY-MM-DD HH:mm:ss';

export default {
  components: {
    CrmPanel,
    CrmButton,
    CrmBlock,
    ChartTotalTimeOptions,
  },
  filters: {
    conversion,
  },
  data() {
    const chartSearchForm = {
      startTimeStr: moment()
        .startOf('month')
        .format(defaultDataFormat),
      endTimeStr: moment()
        .endOf('month')
        .format(defaultDataFormat),
    };

    return {
      loading: false,
      isShown: false,
      time: [],
      totalTime: moment().format(defaultDataFormat),
      timeRangeAlias: 'this-month',
      totalBlockList: [],
      chartSearchForm,
      tableSearchForm: {
        ...chartSearchForm,
        isAgencyTeam: 4,
        pageNumber: 1,
        pageSize: 10,
      },
    };
  },
  computed: {
    ...mapGetters('statistics', {
      tableData: TABLE_GETTER_NAME,
    }),
  },
  mounted() {
    const chartContaiter = document.querySelector('.chart-container');
    chart = echarts.init(chartContaiter, 'light', echartsConfig);
    this.getDiagram();
    this.getTable();
  },
  watch: {
    time: {
      handler: 'handleSelfTimeSearch',
    },
  },
  methods: {
    ...mapActions('statistics', {
      getTableData: TABLE_ACTION_NAME,
    }),
    renderTotalTime() {
      this.totalTime = moment().format(defaultDataFormat);
    },
    handleTimeRangeChange(timeAlias) {
      if (timeAlias === 'self-time') {
        this.isShown = true;
      } else {
        this.isShown = false;
        const { startTime, endTime } = getTimeRangeByAlias(
          timeAlias,
          defaultDataFormat,
        );
        this.chartSearchForm = {
          ...this.chartSearchForm,
          startTimeStr: startTime,
          endTimeStr: endTime,
        };
        this.tableSearchForm = {
          ...this.tableSearchForm,
          startTimeStr: startTime,
          endTimeStr: endTime,
        };
        this.getDiagram();
        this.getTable();
      }
    },
    handleSelfTimeSearch() {
      this.chartSearchForm = {
        ...this.chartSearchForm,
        startTimeStr: this.time[0],
        endTimeStr: this.time[1],
      };
      this.tableSearchForm = {
        ...this.tableSearchForm,
        startTimeStr: this.time[0],
        endTimeStr: this.time[1],
      };
      this.getDiagram();
      this.getTable();
    },
    renderTotalBlock(data) {
      // total: [{ key: 'costAmountTotalStr', value: 0, name: '总成本' }, ...]
      const total = totalFactory(CHART_NAME, data);
      this.totalBlockList = total.map(({ key, value, name }) => {
        const totalComponentProps = CHART_TOTAL_BLOCK_PROPS[key];
        totalComponentProps.theme = value;
        return totalComponentProps;
      });
    },
    renderChart(data) {
      const option = optionFactory(CHART_NAME, data);
      chart.setOption(option);
    },
    // chart ajax
    getDiagram() {
      diagramCommonApi(CHART_NAME, this.chartSearchForm).then((res) => {
        const { reportForm, reportFormTotal } = res.data.data;
        this.renderTotalTime();
        this.renderTotalBlock(reportFormTotal);
        this.renderChart(reportForm);
      });
    },
    // table ajax
    getTable() {
      this.loading = false;
      this.getTableData(this.tableSearchForm).finally(() => {
        this.loading = false;
      });
    },
    handleSizeChange(val) {
      this.tableSearchForm.pageSize = val;
      this.tableSearchForm.pageNumber = 1;

      this.getTable();
    },
    handleCurrentChange(val) {
      this.tableSearchForm.pageNumber = val;
      this.getTable();
    },
  },
};
</script>

<style lang="less" scoped>
.page-statistics-dep2per {
  width: 100%;

  // 图表面板
  .chart-panel {
    padding: 0;
    .tips-container {
      background: rgba(240, 183, 98, 0.1);
      height: 28px;
      line-height: 28px;
      &_text {
        padding-left: 20px;
        color: #7a84b7;
      }
    }
    .select-container {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 20px;
      &_label {
        line-height: 42px;
        font-size: 24px;
        color: #7a84b7;
        padding-right: 30px;
      }
    }
    .total-container {
      display: flex;
      flex-wrap: wrap;
      &_block {
        margin-left: 20px;
        margin-bottom: 20px;
      }
    }
    .chart-container {
      margin: 0 20px 20px 20px;
      height: 220px;
    }
  }

  // 表格面板
  .table-panel {
    margin-top: 20px;
    height: 400px;
  }
}
</style>
